<template>
  <div>
    <Bar text="项目信息"></Bar>
    <div class="e-flex jc-center">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        style="width: 600px"
        label-width="180px"
      >
        <el-form-item label="标段名称" prop="projectName">
          <el-input
            v-model="form.projectName"
            name="projectName"
            placeholder="请填写真实项目名称或标段（包）名称"
          />
        </el-form-item>
    <el-form-item label="项目编号" prop="projectCode">
      <el-input
        v-model="form.projectCode"
        placeholder="请填写真实项目编号或标段（包）编号 "
      />
    </el-form-item>
        <el-form-item label="开标日期" prop="guaranteeStartDate">
          <el-date-picker
            placeholder="请选择开标日期"
            v-model="form.guaranteeStartDate"
            show-time
          />
        </el-form-item>
        <el-form-item label="投标有效期（天）" prop="validityPeriod">
          <el-input
            v-model="form.validityPeriod"
            name="validityPeriod"
            placeholder="请选择投标有效期"
          />
        </el-form-item>
      <el-form-item label="项目地区" prop="rojectArea">
          <el-cascader
            v-model="form.rojectArea"
            :options="options"
            @change="cascaderHandleChange"
          ></el-cascader>
        </el-form-item>
      <el-form-item label="选择担保保险机构" prop="partnerId">
          <el-select
            v-model="form.partnerId"
            placeholder="请选择"
            @change="handleSelect"
          >
            <el-option
              v-for="item in form.partnerList"
              :key="item.id"
              :label="item.channelPartnerShowName"
              :value="item.id"
            ></el-option>
          </el-select>
          <div class="text-red" style="font-size: 12px;">
            {{ issueInsTip }}
          </div>
        </el-form-item>
        <el-form-item label="上传招标文件" prop="tenderFileId">
          <UP
            actionUrl="/zcjf/base/file/upload"
            uploadTitle="上传招标文件"
            @fileIdCb="uploadSuccess"
            :fileId="form.tenderFileId"
            accept =".pdf, .doc, .docx, .rar, .zip, .jpg, .bmp, .gif, .png, .jpeg"
            :filetypes = "['pdf','doc','docx','rar','zip','jpg','bmp','gif','png','jpeg']"
          >
            <template #explain>
              <ul slot="tip" class="el-upload__tip">
                <!-- <li>补遗、澄清等相关文件，请与招标文件一起打包上传</li> -->
                <li>支持PDF、WORD、RAR、ZIP、JPG、BMP、GIF、PNG、JPEG文档</li>
              </ul>
            </template></UP
          >
        </el-form-item>

        <el-form-item
          label="招标人统一社会信用代码"
          :prop="isElectronicIns?'':'tenderSocialCreditCode'"
        >
          <el-input
            v-model="form.tenderSocialCreditCode"
            name="tenderSocialCreditCode"
            placeholder="请填写招标人统一社会信用代码"
          />
        </el-form-item>

        <el-form-item label="招标人名称" prop="tenderCompanyName">
          <el-input
            v-model="form.tenderCompanyName"
            name="tenderCompanyName"
            placeholder="请填写招标人名称"
          />
        </el-form-item>

        <el-form-item label="招标人联系电话" :prop="isElectronicIns?'':'tenderMobilePhone'">
          <el-input
            v-model="form.tenderMobilePhone"
            name="tenderMobilePhone"
            placeholder="请填写招标人联系电话"
          />
        </el-form-item>

       <!--  <el-form-item label="招标人联系邮箱" prop="tenderLinkMail">
          <el-input
            v-model="form.tenderLinkMail"
            name="tenderLinkMail"
            placeholder="请填写项目联系人邮箱"
          />
        </el-form-item>
        <el-form-item label="招标人联系地址" prop="tenderLinkAddress">
          <el-input
            v-model="form.tenderLinkAddress"
            name="tenderLinkAddress"
            placeholder="请填写招标人地址"
          />
        </el-form-item> -->

        <el-form-item :wrapper-col="{ span: 14, offset: 4 }">
          <el-button @click="gopage"> 上一步 </el-button>
          <el-button plain v-if="!$route.query.orderID" @click="saveDraft" :loading="draftSaving">保存</el-button>
          <el-button type="primary" @click="onSubmit"> 下一步 </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  mapMutations,
  mapState,
  INSURANCE,
} from '../../../store/modules/insurance'
import { cloneDeep } from 'lodash'
import { data } from '../../../util/cityData'
import uploadE from '../../../common/upload/uoload.vue'
import bar from '../projectBar/bar'
import { bidderMobilePhonePass, bidderLinkMailPass } from '@/shared/validate'
import { renderArea } from '@/shared/location'
import { queryInsuranceChanelByPcd } from '../../../api/comm'
import { ORDER_TYPE, saveCurrentDraft } from '@/shared/guaranteeDraft'
export default {
  data() {
    const businessLicensePass = (rule, value, callback) => {
      if (this.form.tenderFileId) {
        callback()
      } else {
        callback(new Error('请上传招标文件'))
      }
    }

    const validityPeriod = (rule, value, callback) => {
      if (
        /^\d+$/.test(this.form.validityPeriod) &&
        this.form.validityPeriod > 0
      ) {
        callback()
      } else {
        callback(new Error('请填写大于0的正整数'))
      }
    }

    return {
      form: {},
      bankList: [],
      cityList: [],
      draftSaving: false,
      options: data,
      issueInsTip: '',
      rules: {
        validityPeriod: [
          {
            required: true,
            message: '请填写有效期',
            trigger: 'change',
            validator: validityPeriod,
          },
        ],
        tenderCompanyName: [
          { required: true, message: '请填写标段名称', trigger: 'change' },
        ],
        guaranteeStartDate: {
          required: true,
          message: '请选择开标日期',
          trigger: 'change',
        },
        tenderSocialCreditCode: [
          {
            required: true,
            message: '请填写统一信用验证码',
            trigger: 'change',
          },
        ],
        tenderCompanyName: [
          { required: true, message: '请填写招标人名称', trigger: 'change' },
        ],
        tenderFileId: {
          required: true,
          trigger: 'change',
          validator: businessLicensePass,
        },
        projectName: [
          { required: true, message: '请填写标段信息', trigger: 'change' },
        ],
        tenderMobilePhone: [
          {
            required: true,
            trigger: 'change',
          },
        ],
        projectCode: [
          { required: true, message: '请填写标段编号', trigger: 'change' },
        ],
        bidderLinkName: [
          { required: true, message: '请填写联系人', trigger: 'change' },
        ],
        partnerId: {
          required: true,
          validator: (r, v, callback) => {
            if (this.form.partnerId) {
              callback()
            } else {
              callback(new Error('请选择选择担保保险机构'))
            }
          },
        },
        rojectArea: {
          required: true,
          validator(r, v, callback) {
            if (v) {
              callback()
            } else {
              callback(new Error('请选择项目地区'))
            }
          },
        },
      },
    }
  },
  components: {
    Bar: bar,
    UP: uploadE,
  },

  computed: {
    ...mapState({
      formStorage: 'insurance',
    }),
    //判断是否为电子保险保函
    isElectronicIns() {
      return this.form.exectronic === '1'
    },
  },
  beforeMount() {
    // step 切换恢复：从 Vuex insurance 读（父组件 init(data) 在 nextTick 后覆盖为最新值）
    const { formStorage } = this
    this.form = cloneDeep(formStorage || {})
    this.form.rojectArea = renderArea(this.form)
    const { reapply } = this.$route.query
    this.form.reapply = reapply
    const { province, district, city, apiName, apiId, exectronic } = this.form
    if (province && district && city) {
      queryInsuranceChanelByPcd({ province, district, city, apiName, apiId, guaranteeForm: exectronic }).then((res) => {
        this.form.partnerList = cloneDeep(res.data)
        const defaultData = this.form.partnerList.filter((val) => val.id == this.form.partnerId)
        if (defaultData && defaultData.length > 0) {
          this.handleSelect(this.form.partnerId)
        } else {
          if (
            res.data[0].accountNo != undefined &&
            res.data[0].chargeProductType.includes('7000')
          ) {
            this.form.payee = '2'
          } else {
            this.form.payee = '1'
          }
          this.form.partnerId = res.data[0].id
          this.form.partnerName = res.data[0].channelPartnerName
          this.issueInsTip = res.data[0]?.issueInsTip || ''
        }
        this.$forceUpdate()
      })
    }
    this.$forceUpdate()
  },
  methods: {
    ...mapMutations({
      in: INSURANCE.INSURANCE,
    }),
    init(data) {
      this.form = cloneDeep(data || {})
    },
    uploadSuccess(res) {
      this.form.tenderFileId = res.url
      this.$refs.form.validateField('tenderFileId')
    },
    gopage() {
      this.in(this.form)
      this.$emit('changeIndex', 0)
    },
    onSubmit() {
      if(!['130000','120000','110000'].includes(this.form.province) && this.form.applicationChannelId === 30){
        this.$alert('根据保监会规定，在京津冀省（市）均已设立省级分公司的保险公司，不得开展跨区域经营，本平台由中华联合财产保险股份有限公司衡水中心支公司出函，无法出具京津冀省（市）以外地区项目的保险保函，请您办理本平台其他类型保函', '提示', {confirmButtonText: '确定'});
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.in(this.form)
          this.$emit('changeIndex', 2)
        }
      })
    },
    async saveDraft() {
      this.draftSaving = true
      try {
        await saveCurrentDraft(this, ORDER_TYPE.INSURANCE_7000, 1, this.form)
      } finally {
        this.draftSaving = false
      }
    },
    handleSelect(e) {
     const partnerInfo = this.form.partnerList.find((i) => i.id == e)
       this.form.partnerName = partnerInfo?.channelPartnerName
       const chargeProductType = partnerInfo?.chargeProductType
       const accountNo = partnerInfo?.accountNo
       this.issueInsTip = partnerInfo?.issueInsTip
      //判断是否机构收费
      if (accountNo != undefined && chargeProductType != undefined && chargeProductType.includes('7000')) {
       this.form.payee = '2'
      } else {
       this.form.payee = '1'
      }
      this.form.partnerId = partnerInfo?.id
      this.$forceUpdate()
    },
    cascaderHandleChange(e) {
      this.form.partnerId = null
      this.$nextTick(() => {
        this.$refs.form.clearValidate('partnerId')
      })
      const [province, city, district, apiName, apiId] = [
        e[0],
        e[1],
        e[2],
        this.form.apiName,
        this.form.apiId
      ]

      this.form = Object.assign(this.form, {
        province: province,
        district: district,
        city: city,
        apiName: apiName,
        apiId: apiId
      })
      this.form.rojectArea = renderArea(this.form)
      queryInsuranceChanelByPcd({ province, district, city, apiName, apiId,guaranteeForm:this.form.exectronic}).then((res) => {
        this.form.partnerList = cloneDeep(res.data)
        if (res.data.length === 1) {
          //判断是否机构收费 机构收费线下打款
          if (
            res.data[0].accountNo != undefined &&
            res.data[0].chargeProductType.includes('7000')
          ) {
            this.form.payee = '2'
          } else {
            this.form.payee = '1'
          }
          this.form.partnerId = res.data[0].id
          this.form.partnerName = res.data[0].channelPartnerName
          const issueInsTip = res.data[0]?.issueInsTip || ''
          this.issueInsTip = issueInsTip
        }
        this.$forceUpdate()
      })
    },
  },
}
</script>
